export default "__VITE_ASSET__DkumXE6e__"